import React from 'react';
import { Mail, Phone, Linkedin, Instagram } from 'lucide-react';

export const Footer = () => {
  return (
    <footer style={styles.footer}>
      <div style={styles.container}>
        <div style={styles.content} className="footer-content">
          <div style={styles.brandSection}>
            <div style={styles.logo}>
              <span style={styles.logoText}>NAHHAS</span>
              <span style={styles.logoSubtext}>LUXURY CONSULTING</span>
            </div>
            <p style={styles.tagline}>
              Excellence en consulting de luxe pour l'hospitalité, l'immobilier et les investissements
            </p>
          </div>

          <div style={styles.linksSection}>
            <h4 style={styles.sectionTitle}>Navigation</h4>
            <a href="#home" style={styles.link}>Accueil</a>
            <a href="#about" style={styles.link}>À Propos</a>
            <a href="#services" style={styles.link}>Services</a>
            <a href="#contact" style={styles.link}>Contact</a>
          </div>

          <div style={styles.contactSection}>
            <h4 style={styles.sectionTitle}>Contact</h4>
            <div style={styles.contactItem}>
              <Mail size={16} style={styles.contactIcon} />
              <a href="mailto:younesnahhas@gmail.com" style={styles.link}>
                younesnahhas@gmail.com
              </a>
            </div>
            <div style={styles.contactItem}>
              <Phone size={16} style={styles.contactIcon} />
              <a href="tel:0768211350" style={styles.link}>
                07 68 21 13 50
              </a>
            </div>
          </div>

          <div style={styles.socialSection}>
            <h4 style={styles.sectionTitle}>Suivez-nous</h4>
            <div style={styles.socialLinks}>
              <a href="#" style={styles.socialIcon}>
                <Linkedin size={24} />
              </a>
              <a href="#" style={styles.socialIcon}>
                <Instagram size={24} />
              </a>
            </div>
          </div>
        </div>

        <div style={styles.bottom}>
          <p style={styles.copyright}>
            © {new Date().getFullYear()} Nahhas Luxury Consulting. Tous droits réservés.
          </p>
        </div>
      </div>
    </footer>
  );
};

const styles = {
  footer: {
    background: '#0a0a0a',
    borderTop: '1px solid rgba(212, 175, 55, 0.2)',
    padding: '80px 40px 30px',
  },
  container: {
    maxWidth: '1400px',
    margin: '0 auto',
  },
  content: {
    display: 'grid',
    gridTemplateColumns: '2fr 1fr 1fr 1fr',
    gap: '60px',
    marginBottom: '60px',
  },
  brandSection: {
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
  },
  logo: {
    display: 'flex',
    flexDirection: 'column',
    gap: '2px',
  },
  logoText: {
    fontSize: '24px',
    fontWeight: '700',
    color: '#D4AF37',
    letterSpacing: '2px',
  },
  logoSubtext: {
    fontSize: '10px',
    fontWeight: '400',
    color: '#FFFFFF',
    letterSpacing: '3px',
  },
  tagline: {
    fontSize: '14px',
    color: 'rgba(255, 255, 255, 0.6)',
    lineHeight: '1.6',
    maxWidth: '300px',
  },
  linksSection: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
  },
  contactSection: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
  },
  socialSection: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
  },
  sectionTitle: {
    fontSize: '14px',
    fontWeight: '600',
    color: '#D4AF37',
    textTransform: 'uppercase',
    letterSpacing: '1px',
    marginBottom: '8px',
  },
  link: {
    fontSize: '14px',
    color: 'rgba(255, 255, 255, 0.7)',
    textDecoration: 'none',
    transition: 'color 0.3s ease',
  },
  contactItem: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },
  contactIcon: {
    color: '#D4AF37',
  },
  socialLinks: {
    display: 'flex',
    gap: '16px',
  },
  socialIcon: {
    color: '#D4AF37',
    transition: 'transform 0.3s ease',
  },
  bottom: {
    borderTop: '1px solid rgba(212, 175, 55, 0.1)',
    paddingTop: '30px',
    textAlign: 'center',
  },
  copyright: {
    fontSize: '14px',
    color: 'rgba(255, 255, 255, 0.5)',
  },
};